import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { auth } from "helper/Utility";
import { scheduleAutoLogout, clearAutoLogout } from "helper/tokenExpiry";

const ProtectedSalespersonRoute = ({ children }) => {
    const navigate = useNavigate();
    const authData = auth("salesperson");

    if (!authData?.token) {
        return <Navigate to="/admin/login" replace />;
    }

    if (authData?.role !== "salesperson") {
        return <Navigate to="/admin/login" replace />;
    }

    try {
        const payload = JSON.parse(atob(authData.token.split('.')[1]));
        if (payload.exp * 1000 < Date.now()) {
            sessionStorage.clear();
            return <Navigate to="/admin/login" replace />;
        }
    } catch (e) {
        sessionStorage.clear();
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <SpTokenExpiryWatcher navigate={navigate}>
            {children}
        </SpTokenExpiryWatcher>
    );
};

const SpTokenExpiryWatcher = ({ children, navigate }) => {
    useEffect(() => {
        scheduleAutoLogout(() => {
            sessionStorage.clear();
            navigate('/admin/login', { replace: true });
        });
        return () => clearAutoLogout();
    }, [navigate]);

    return children;
};

export default ProtectedSalespersonRoute;
